import { render, staticRenderFns } from "./NexiaLogo.vue?vue&type=template&id=40fa6364&scoped=true"
import script from "./NexiaLogo.vue?vue&type=script&lang=js"
export * from "./NexiaLogo.vue?vue&type=script&lang=js"
import style0 from "./NexiaLogo.vue?vue&type=style&index=0&id=40fa6364&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fa6364",
  null
  
)

export default component.exports